module.exports = __webpack_public_path__ + "desc.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/desc.svg?color1=%23333333&color2=
// module id = 910
// module chunks = 67